import React from 'react';
import { Spinner, Table } from 'react-bootstrap';

import RelatorioTable, { formatNumberBR } from 'components/Relatorios/shared/RelatorioTable';
import Card from 'components/DesignSystem/Card';

import useDecompSecaoParams from 'hooks/Relatorios/Decomp/useDecompSecaoParams';
import { useGetDecompResultadosQuery } from 'services/api/products/relatorios';

const SUBMERCADOS = ['SE', 'S', 'NE', 'N'];

export default function Resultados() {
  const params = useDecompSecaoParams();

  const { data, isLoading } = useGetDecompResultadosQuery(params);

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center p-3">
        <Spinner animation="border" role="status" />
      </div>
    );
  }

  if (!data) {
    return null;
  }

  const enaColumns = ['Subsistema', ...data.ena.colunas];
  const enaRows = data.ena.linhas.map((linha) => [
    linha.subsistema,
    ...linha.semanas,
    linha.mlt,
    `${formatNumberBR(linha.pct_mlt)}%`,
  ]);

  return (
    <div className="decomp-resultados">
      <Card title="Preços" className="relatorio-table">
        <Table responsive hover>
          <thead>
            <tr>
              <th rowSpan={2}>Patamar</th>
              <th colSpan={4}>PLD com Limites</th>
              <th colSpan={4}>PLD sem Limites</th>
            </tr>
            <tr>
              <th>SE</th>
              <th>S</th>
              <th>NE</th>
              <th>N</th>
              <th>SE</th>
              <th>S</th>
              <th>NE</th>
              <th>N</th>
            </tr>
          </thead>
          <tbody>
            {data.precos.patamares.map((linha) => (
              <tr key={linha.patamar}>
                <td>{linha.patamar}</td>
                {SUBMERCADOS.map((sub) => (
                  <td key={`com-${sub}`}>{formatNumberBR(linha.com_limites[sub])}</td>
                ))}
                {SUBMERCADOS.map((sub) => (
                  <td key={`sem-${sub}`}>{formatNumberBR(linha.sem_limites[sub])}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </Table>
      </Card>
      <div>
        <RelatorioTable
          titulo="Energia Naturalmente Afluente"
          columns={enaColumns}
          rows={enaRows}
        />
      </div>
    </div>
  );
}
